export default __webpack_public_path__ + "static/lframe-home-cc9768cd936e40e16991bdec8db54125.png";